
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Activity } from '../activity.service';
import { RiderService } from '../../riders/rider.service';

interface DialogData {
  activity: Activity;
  canAssign?: boolean;
  statuses?: string[];
}

@Component({
  selector: 'app-activity-dialog',
  templateUrl: './activity-dialog.component.html',
  styleUrls: ['./activity-dialog.component.scss']
})
export class ActivityDialogComponent implements OnInit {
  form!: FormGroup;
  riders: any[] = [];
  statuses: string[] = ['Pending', 'Assigned', 'In Transit', 'Delivered', 'Cancelled'];
  isLoadingRiders = true;

  constructor(
    private fb: FormBuilder,
    private riderService: RiderService, // ✅ use your RiderService
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    const activity = this.data.activity;
    this.form = this.fb.group({
      riderId: [activity.assignedRider || ''],
      status: [activity.status || 'Pending']
    });

    this.statuses = this.data.statuses?.length ? this.data.statuses : this.statuses;
    if (!this.statuses.includes(this.form.value.status)) {
      this.form.patchValue({ status: this.statuses[0] || activity.status || 'In Transit' });
    }

    if (this.canAssign()) {
      this.loadRiders();
    } else {
      this.isLoadingRiders = false;
      this.form.get('riderId')?.disable();
    }
  }

  /** ✅ Fetch riders from existing RiderService */
  loadRiders(): void {
    this.isLoadingRiders = true;
    console.log('%c[ActivityDialog] 🔄 Loading active riders...', 'color: dodgerblue');

    this.riderService.getRiders().subscribe({
      next: (res) => {
        this.riders = res || [];
        this.isLoadingRiders = false;
        console.log('%c[ActivityDialog] ✅ Riders loaded:', 'color: green', this.riders);
      },
      error: (err) => {
        this.isLoadingRiders = false;
        console.error('[ActivityDialog] ❌ Failed to load riders:', err);
      }
    });
  }

  /** ✅ Return selected values to parent component */
  save(): void {
    if (this.form.valid) {
      const selectedRider = this.riders.find(r => r.id === this.form.value.riderId);
      const riderName = selectedRider ? (selectedRider.fullName || selectedRider.name || selectedRider.email) : '';
      this.dialogRef.close({
        ...this.form.value,
        riderName
      });
    }
  }
  

  cancel(): void {
    this.dialogRef.close(null);
  }

  canAssign(): boolean {
    return this.data.canAssign !== false;
  }
}
